import { Link } from 'features/i18n/router'
import { useEffect, useState } from 'react'
import { isNil, last } from 'lodash'

import { useTranslation } from 'react-i18next'
import { appendList } from 'lib/helpers'
import { ChatRoomType } from 'lib/_types'
import { useInfinityScrollSimple } from 'hooks'
import { useGetRequestChatRoomListQuery } from 'store/api/yay/chat'
import usePageModal from 'features/Modal/hooks/usePageModal'
import ChatRoomList from 'features/Chat/components/ChatRoomList'

import './style.scss'
import { ROUTE_PATH } from 'lib/paths'

const RequestChatListModal = () => {
  const { t } = useTranslation()

  const [__fromTimestamp, __fromTimestampSet] = useState('0')
  const [__chatRooms, __chatRoomsSet] = useState<ChatRoomType[]>([])

  const getRequestChatRoomListRes = useGetRequestChatRoomListQuery({
    fromTimestamp: __fromTimestamp,
  })

  const loadMore = () => {
    const fromTimestamp =
      getRequestChatRoomListRes?.data?.next_page_value ??
      (last(getRequestChatRoomListRes?.data?.chat_rooms), 'updated_at')

    __fromTimestampSet(fromTimestamp?.toString?.())
  }

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore,
  })

  useEffect(() => {
    __chatRoomsSet((prevState) => {
      return appendList(
        prevState,
        getRequestChatRoomListRes?.data?.chat_rooms,
        'updated_at'
      )
    })
  }, [getRequestChatRoomListRes])

  return (
    <div className="Modal__wrapper">
      <div className="Modal__header">
        <Link
          className="Modal__header__close Modal__header__close--back"
          to={ROUTE_PATH.CHAT}
        />

        <h2 className="Modal__header__h2">
          {t('request_chat_list_modal.title')}
        </h2>
      </div>

      <div className="Modal__body Modal__body--gray">
        <div className="RequestChatListModal__title">
          {t('request_chat_list_modal.content')}
        </div>

        <ChatRoomList
          isLoading={getRequestChatRoomListRes.isLoading}
          chatRooms={__chatRooms}
          onLoadMore={loadMore}
          isFullyLoaded={isNil(
            getRequestChatRoomListRes?.data?.next_page_value
          )}
          loadMoreRef={loadMoreRef}
          hideable={false}
          reloadOnDelete
          isRequestChats
        />
      </div>
    </div>
  )
}

export default RequestChatListModal
